// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1WwQs","content":"Page_content__Og_kP","scrollingDisabled":"Page_scrollingDisabled__14FMH"};